import Porter from '@alife/mscc-porter';
import Cookie from '@alife/mscc-cookie';

import {
  isInApp,
  parseStr,
  isCsFormPage,
  isCsSuccessPage,
  isContainerPathname
} from './common/utils';
import {
  getStorage,
  setStorage
} from './common/localStorage';
import listenDownloadApp from './listen-download-app';

import SmartDA from './modules/download-app/smart';
import ForceDA from './modules/download-app/force';
// import Questionnaire from './modules/questionnaire';

// 只有不在APP的情况下才执行逻辑
if (!isInApp()) init()

function init() {
  // 监听所有引流点击
  listenDownloadApp();
  // 显示智能引流，后端不愿意控制，就只能显示在前端了
  ~function handlerSmartDA() {
    const isMsite = /^m.*alibaba.com$/.test(window.location.host);
    const notShowPathnames = ['/login.html', '/register.htm', '/atmHistory', '/atmChatRoom'];
    if (isMsite && !isCsFormPage() && !isContainerPathname(notShowPathnames)) {
      showSmartDA()
    }
    function showSmartDA () {
      // 声明常量
      const APPNAME = 'wap2';
      const APPID = 'icbu_wap2';
      const APPKEY = 'zmgzskyts9twmwzymd5jzsiho72lviws';
      var apushClient = null;

      //预发
      // Apush2.serverDomain = 'hz-apush-fb.aliexpress.com';

      //线上
      Apush2.serverDomain = 'hzapush.aliexpress.com';
      Apush2.port = 80;

      // 和Apush建立链接
      // 临时hack 当为询盘表单页面时，不弹出引流框
      if (!apushClient) {
        const TokenUrl = `/openservice/apushAuthorizeTokenService?appKey=${APPKEY}&appName=${APPNAME}&cna=${Cookie.getCna()}`;
        const terminalId = null; //不填则系统生成一个随机字符窜作为terminalId
        const terminalType = null; //不填则系统默认为pc
        apushClient = Apush2.createClient(APPID, TokenUrl, msgCallback, terminalId, terminalType, connectCallback);
      }

      // 成功建立链接
      function connectCallback(msg) {
        // 和后端建立连接，发送当前refer和cna等信息
        const sendRerferUrl = `/openservice/drainageTimeViewService?appKey=${APPKEY}&appName=${APPNAME}&pageReferer=${window.document.referrer}`;
        Porter.get(sendRerferUrl);
      }

      // 处理收到的消息
      function msgCallback(msg) {
        const result = parseStr(msg.arg) || {};

        // 如果服务器端要求关闭链接，则关闭
        if (result.data.needCloseConnection) {
          closeClient()
        }

        // 业务逻辑处理
        if (msg.msgType === "timeDrainageMsg") {
          if (!result.status) return;
          // 因为每次的弹框都不一样，所以需要初始化弹框
          const smartDA = new SmartDA(result.data);
          smartDA.show();
        }

      }

      //断开连接并销毁client
      function closeClient() {
        if (apushClient != null) {
          apushClient.close();
          apushClient = null;
        }
      }
    }
  }()

  // 显示强制引流
  ~function handlerForceDA () {
    new ForceDA();
  }()
  
  // 显示问卷，临时把控制权写在前端，后期会对接到后端
  // ~ function handlerQuestionnaire() {
    
  //   const { pathname } = window.location;

  //   // 首页问卷
  //   if (pathname === '/') {
  //     showQuestionnaire('homepage', 'hasQuestionnaireShowIndex');
  //   }
  //   // detail页问卷 因为和新手引导冲突，所以暂时下掉
  //   // if (/^\/product\//.test(pathname)) {
  //   //   showQuestionnaire('detail', 'hasQuestionnaireShowDetail');
  //   // }

  //   // Message问卷
  //   if (/^\/atmHistory/.test(pathname)) {
  //     showQuestionnaire('message', 'hasQuestionnaireShowMessage');
  //   }
  //   // 询盘成功页问卷 
  //   if (isCsSuccessPage()) {
  //     showQuestionnaire('cs-success', 'hasQuestionnaireShowCsSuccess');
  //   } 
  //   // 订单失败页问卷
  //   if (pathname === '/order/start_error.html') {
  //     showQuestionnaire('order-fail', 'hasQuestionnaireShowDetailOrderFail');
  //   }
  //   function showQuestionnaire (page, localStorage) {
  //     if (getStorage(localStorage)) return;

  //     setStorage(localStorage, true);

  //     // 显示问卷
  //     window.__questionnaire({
  //       source: page
  //     });
  //   }
  // }()
}



// WEBPACK FOOTER //
// ./src/index.js